const customerMapping = [{
  desc: '人员映射列表',
  options: {
    url: '/customerMapping/queryList',
    method: 'post'
  }
}, {
  desc: '编辑人员映射',
  options: {
    url: '/customerMapping/saveMapping',
    method: 'post'
  }
}]
export default customerMapping



// WEBPACK FOOTER //
// ./src/api/customerMapping.js